//Liste des fichiers exportés par contrat avec la possibilité de les télécharger, disponible
// à travers une popup accessible depuis le menu d'export/import, via le bouton Partage

import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import ModalFlexible from 'saur_ui_library/src/Organisms/ModalFlexible/ModalFlexible';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import React, { FC, useEffect, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import Error from '../../components/common/ErrorMessage';
import Loader from './Loader';
import { ParameterApi } from '../../utils/api';
import Folder from '../common/Icon/Folder.svg';
import { useSelector } from 'react-redux';
import { initialState } from '../../redux/reducers/contracts';
import { v4 as uuidv4 } from 'uuid';

type PartageProps = {
  IsVisible: any;
  setModalVisible: any;
};

const Partage: FC<PartageProps> = (props) => {
  //variables
  //permet de récuperer l'ensemble des dossiers exportés
  const [filesList, setFilesList] = useState<any>([]);
  //  fenêtre d'erreur
  const [error, setError] = React.useState(false);
  //page de chargement
  const [loading, setLoading] = React.useState(false);
  //toast d'affichage de message en cas de succès ou d'échec de télechargement
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);
  const sessionContractCode =
    window.sessionStorage.getItem('contractCode') || '';
  const contractCode = useSelector((state: typeof initialState) => state?.code);

  //fonction de récupération de la liste des dossiers

  const getFilesList = async (actualCode: any) => {
    try {
      setLoading(true);
      const result = await ParameterApi.getFolderList(actualCode);
      setFilesList(result.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      setError(true);
    }
  };

  //mettre à jour la fenetre des que le contrat change
  useEffect(() => {
    if (contractCode !== null && contractCode.length) {
      getFilesList(contractCode);
    } else {
      getFilesList(sessionContractCode);
    }
  }, [contractCode, sessionContractCode]);

  //fonction de téléchargement du contenu du dossier sélectionner
  const downLoadFiles = async (blobName: any) => {
    try {
      setLoading(true);
      const response = await ParameterApi.getFiles(blobName);
      const blob = new Blob([response.data], {
        type: 'application/octet-stream',
      });
      const fileName = blobName + '.zip';
      saveAs(blob, fileName);
      if (contractCode !== null && contractCode.length) {
        getFilesList(contractCode);
      } else {
        getFilesList(sessionContractCode);
      }
      setLoading(false);
      toastSucess.current?.show({
        severity: 'success',
        summary: 'Succès',
        detail: 'Dossier enregistré avec succès',
        life: 5000,
      });
    } catch (e) {
      setLoading(false);
      toastError.current?.show({
        severity: 'error',
        summary: 'Erreur',
        detail:
          'Votre dossier semble présenter une erreur au téléchargement. Veuillez réessayer. ',
        life: 5000,
      });
    }
  };

  //render function for one elementList

  function renderElementList() {
    return (
      <>
        {filesList.map((value: any) => {
          return (
            <Card className='list-element' id='list-element' key={uuidv4()}>
              <Container className='element-line'>
                <img
                  className='folder-image'
                  id='folder-image'
                  alt='folder'
                  src={Folder}
                ></img>
                <Word
                  value={value}
                  textStyle='titleSmall'
                  variant='p'
                  automatedTestId='nom-dossier'
                />
                <StyledSectionButton>
                  <Button
                    automatedTestId='partage-btn'
                    className='partage-btn'
                    mode='outline'
                    onClick={() => downLoadFiles(value)}
                  >
                    <Word
                      variant='span'
                      textStyle='normalBold'
                      value='Télécharger'
                      automatedTestId='partage-btn-text'
                    />
                  </Button>
                </StyledSectionButton>
              </Container>
            </Card>
          );
        })}
      </>
    );
  }

  const popupContent = () => (
    <Container className='modalSizeContainer'>{renderElementList()}</Container>
  );

  //Html
  return (
    <Container className='global-Import-container'>
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      <ModalFlexible
        showHeader
        className='PartageContainer'
        title='Liste des fichiers exportés'
        toggleModal={props.setModalVisible}
        visible={props.IsVisible}
        desktopContent={popupContent}
      />
      {loading ? (
        <Container automatedTestId='loader' className='loader'>
          <Loader IsVisible={true} />
        </Container>
      ) : null}
      {error ? <Error IsVisible={error}></Error> : null}
    </Container>
  );
};
const StyledSectionButton = styled(Container)`
  flex-direction: row;
  justify-content: space-around;
`;
const Styles = createGlobalStyle`
    .sds-reset-style{
      .global-Import-container{
        background-color:#CCE9F7;
        .modal-flex-desktop-content-title {
          color: #1156B2;
        } 
        .modal-flex-desktop .modal-flex-desktop-overlay .modal-flex-desktop-position .modal-flex-desktop-content .modal-flex-desktop-header {
          align-items: flex-end !important;
          padding: 0px !important;
          height: max-content;
          flex-direction: column !important;
        }
        .modal-flex-mobile-header{
          display: none;
        }
        .list-element {
          /* background: #CCE9F7; */
          margin-bottom: 10px;
        }
        .element-line{
          flex-direction: row;
          justify-content: space-between;
          #nom-dossier{
            line-height: 5;
            font-size: 14px;
            color: black !important;
            font-weight: 700 !important;
          }
        }
        img#folder-image.folder-image{
          width: 5%;
          fill: #008BD2;
        }
        
        .PartageContainer{
          z-index:200;  
          div.modal-flex-desktop-content{
          width: 100vh;
          }
         
        .modalSizeContainer{
          margin-bottom: 2%;
          .dropdown-icon-container svg{
            width:15px;
          }
        }
      }
    }
  }
  `;
export default Partage;
